module.exports = __webpack_public_path__ + "img/customer-service.f0382bf3.svg";